import { useQuery } from '@tanstack/react-query'

import { API_BASE_URL } from '../constants.ts'
import type { Scout, ScoutFilters } from '../types.ts'

import { httpClient } from '@/shared/utils/http-client.ts'

export const fetchScouts = async (filters?: ScoutFilters) => {
  const params = new URLSearchParams()

  // Add pagination params
  const limit = filters?.limit || 10
  const offset = filters?.offset || 0
  params.append('limit', limit.toString())
  params.append('offset', offset.toString())

  // Add search query parameter
  if (filters?.q) {
    params.append('q', filters.q)
  }

  // Add status filter parameter
  if (filters?.status) {
    if (Array.isArray(filters.status)) {
      filters.status.forEach(status => params.append('status', status))
    } else {
      params.append('status', filters.status)
    }
  }

  const response = await httpClient.fetch(`${API_BASE_URL}/scout?${params.toString()}`)

  if (!response.ok) {
    throw new Error('Failed to fetch scouts')
  }

  // API returns { data: Scout[], count: number }
  const rawData = (await response.json()) as { data: Scout[]; count: number }

  const { data, count } = rawData

  return {
    data,
    total: count,
  }
}

export const useScoutsQuery = (filters?: ScoutFilters, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['scouts', filters],
    queryFn: () => fetchScouts(filters),
    enabled: options?.enabled !== undefined ? options.enabled : true,
  })
}
